<template>
  <div>
    <van-tabs
      class="tabs"
      v-model="active"
      color="#FFC929"
      title-active-color="#FFC929"
      @click="changeTabs"
    >
      <van-tab title="我要保险" class="tab">
        <Login ref="Login"/>
      </van-tab>
      <van-tab title="公司简介" class="tab">
        <companyProfile :imgUrl="imgUrl" v-if="imgUrl.length>0" ref="shuju"/>
      </van-tab>
      <van-tab title="承保方案" class="tab">
        <insurancePlan :imgUrl="imgUrl" v-if="imgUrl.length>0" ref="insurancePlan"/>
      </van-tab>
      <van-tab title="理赔方案" class="tab">
        <compensationScheme :imgUrl="imgUrl" v-if="imgUrl.length>0" ref="compensationScheme"/>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import api from "@/api/api.js";
import Login from "@/pages/Login/Login";
import companyProfile from "@/pages/Index/companyProfile/index";
import insurancePlan from "@/pages/Index/insurancePlan/index";
import compensationScheme from "@/pages/Index/compensationScheme/index";

export default {
  components: {
    Login,
    companyProfile,
    insurancePlan,
    compensationScheme
  },
  data() {
    return {
      active: 1, // 激活的tab
      imgUrl: [],
      loadList: [],
      activityId: ""
    };
  },
  created() {
    let href = window.location.href;
    let object = {};
    href
      .substring(href.indexOf("?") + 1)
      .split("#")[0]
      .split("&")
      .forEach(value => {
        let values = value.split("=");
        object[values[0]] = values[1];
      });
      if(object.activityId!=undefined){
            this.activityId = object.activityId;
      }
    this.changeTabs(0);
  },
  methods: {
    changeTabs(val) {
      this.active = val;
      if (!localStorage.getItem("imgUrl1")) {
        this.doGet();
      } else {
        this.imgUrl = localStorage.getItem("imgUrl1");
        this.imgUrl = this.imgUrl.split(",");
      }
    },
    doGet() {
      this.$http.get(api.imgallurls + this.activityId).then(res => {
          if (res.data.data != null) {
            let data = res.data.data;
            let images = JSON.parse(data);
            this.imgUrl = images.images;
            localStorage.setItem("imgUrl1", images.images);
          }
        }).catch(error => {});
    }
  }
};
</script>
<style>
.van-tab {
  font-size: 0.18rem;
  /*font-family: PingFangSC-Regular, PingFang SC;*/
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.van-tab span {
  line-height: 0.79rem !important;
}
.van-tabs__nav--line {
  background: rgba(153, 91, 204, 1);
}
</style>

<style lang="scss" scoped>
@import "./app.scss";
</style>



// WEBPACK FOOTER //
// src/pages/Index/Index.vue